export default [
  {
    path: 'transfer/contact',
    name: 'Contacts List',
    component: () => import('@/views/transfer/contact/list/index.vue'),
    meta: {
      icon: 'icon-transfer',
      resourceCode: 'transfer:contact',
      parentResourceCode: 'bigPayout',
    },
  },
  {
    path: 'transfer/contact/aggregate/:type',
    name: 'Contacts List',
    component: () => import('@/views/transfer/contact/list/index_aggregate.vue'),
    meta: {
      icon: 'icon-transfer',
      resourceCode: 'transfer:contact',
      parentResourceCode: 'bigPayout',
    },
  },
  {
    path: 'transfer/contact/edit',
    name: 'Contacts Edit',
    component: () => import('@/views/transfer/contact/edit/index.vue'),
    meta: {
      resourceCode: 'transfer:contact:edit',
      hideMenu: true,
    },
  },
  {
    path: '/transfer/transfer',
    name: 'Transfer',
    component: () => import('@/views/transfer/transfer/list/index.vue'),
    meta: {
      resourceCode: 'transfer:transfer',
    },
  },
  {
    path: '/transfer/transfer/aggregate/:type',
    name: 'Transfer Aggregate',
    component: () => import('@/views/transfer/transfer/list/index_aggregate.vue'),
    meta: {
      resourceCode: 'transfer:transfer',
    },
  },
  {
    path: '/transfer/transfer/view',
    name: 'Transfer details',
    component: () => import('@/views/transfer/transfer/view/index.vue'),
    meta: {
      resourceCode: 'transfer:transfer:view',
      name: 'message.transfer.details',
      activeMenu: '/transfer/transfer',
    },
  },
  {
    path: '/transfer/transfer/add/recipient',
    name: 'Transfer money recipient',
    component: () => import('@/views/transfer/transfer/add/recipient/index.vue'),
    meta: {
      resourceCode: 'transfer:transfer:add',
      hideMenu: true,
    },
  },
  {
    path: '/transfer/transfer/add/amount',
    name: 'Transfer money amount',
    component: () => import('@/views/transfer/transfer/add/amount/index.vue'),
    meta: {
      resourceCode: 'transfer:transfer:add',
      hideMenu: true,
    },
  },
  {
    path: '/transfer/transfer/add/confirm',
    name: 'Transfer money confirm',
    component: () => import('@/views/transfer/transfer/add/amount/confirm.vue'),
    meta: {
      // resourceCode: 'transfer:transfer:add',
      hideMenu: true,
    },
  },
  {
    path: '/transfer/transfer/add/review',
    name: 'Transfer money review',
    component: () => import('@/views/transfer/transfer/add/review/index.vue'),
    meta: {
      resourceCode: 'transfer:transfer:add',
      hideMenu: true,
    },
  },
  {
    path: '/transfer/available-limit',
    name: 'Available limit',
    component: () => import('@/views/transfer/available-limit/list/index.vue'),
    meta: {
      resourceCode: 'transfer:availableLimit',
    },
  },
];
